module.exports = __webpack_public_path__ + "img/operation_state.3e46d46f.png";